export const ruleMailboxScopeFields = (rule = {}) => {
  const mailboxScope = rule.mailboxScope || 'ALL'
  const mailboxIds = rule.mailboxIds || []
  return {
    mailboxScope,
    mailboxIds,
    // Drafts retain the original loaded scope, not the edited selection.
    mailboxScopeBaseline: rule.mailboxScopeBaseline || {
      mailboxScope,
      mailboxIds: [...mailboxIds],
    },
  }
}

export const hasRuleMailboxScopeChanged = rule => {
  const baseline = rule.mailboxScopeBaseline
  if (!baseline) return false
  if (rule.mailboxScope !== baseline.mailboxScope) return true
  if (rule.mailboxScope === 'ALL') return false
  const ids = new Set(rule.mailboxIds)
  const baselineIds = new Set(baseline.mailboxIds)
  return (
    ids.size !== baselineIds.size || [...ids].some(id => !baselineIds.has(id))
  )
}

export const ruleMailboxScopeVariables = (rule, { isCreate = false } = {}) => {
  if (!isCreate && !hasRuleMailboxScopeChanged(rule)) return {}
  return {
    mailboxIds:
      rule.mailboxScope === 'SELECTED' ? [...new Set(rule.mailboxIds)] : [],
  }
}

export const existingRuleMailboxIds = (ids = [], mailboxes = []) => {
  const accountIds = new Set(mailboxes.map(mailbox => mailbox.gid))
  return [...new Set(ids)].filter(id => accountIds.has(id))
}

export const ruleMailboxScopeValidation = (rule, mailboxes, isUpdate) => {
  if (rule.mailboxScope !== 'SELECTED') return true
  if (isUpdate && !hasRuleMailboxScopeChanged(rule)) return true
  return existingRuleMailboxIds(rule.mailboxIds, mailboxes).length > 0
}

export const ruleMailboxScopeWarning = (rule, mailboxes) => {
  if (rule.mailboxScope !== 'SELECTED') return null
  const count = existingRuleMailboxIds(rule.mailboxIds, mailboxes).length
  if (!count)
    return 'No selected mailboxes exist. This rule applies to no mailboxes.'
  if (count < new Set(rule.mailboxIds).size)
    return 'Some selected mailboxes no longer exist.'
  return null
}

export const ruleMailboxScopeSummary = (rule, mailboxes) => {
  if (rule.mailboxScope !== 'SELECTED') return null
  const count = existingRuleMailboxIds(rule.mailboxIds, mailboxes).length
  if (!count) return 'No mailboxes'
  return count === 1 ? '1 mailbox' : `${count} mailboxes`
}

export const ruleMailboxScopeError = error =>
  error?.errors?.find(item => item.path?.join('.') === 'input.mailboxIds')
    ?.message
